/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useLayoutEffect, useEffect, useRef } from 'react'
import { Messages } from 'primereact/messages';

import logo from '../../../../Assets/Logo_PPF_small.png'
import { formatNumber, fechaLocalTemplate, textCenterTemplate } from '../../../../Base/Services/TemplatesServices'
import { getEncabezadoRequisa } from '../../../../API/Compras/Requisas/PurchaseRequests'
import { getDetalleRequisa } from '../../../../API/Compras/Requisas/PurchareDetailsRequests'

import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon'
import { textTemplate } from '../../../../Base/Services/TemplatesServices'

import { firmas } from '../../../../Services/Firmas/FirmasService';

import './RequisasComprasReporte.scss'

const RequisasComprasReporte = ({ Numero }) => {

  const messages = useRef(null);


  const [purchaseInfo, setPurchaseInfo] = useState(null);
  const [purchaseDetalle, setPurchaseDetalle] = useState([]);


  // PERMISOS
  const [permiso1, setPermiso1] = useState(null);
  const [permiso3, setPermiso3] = useState(null);
  const [permiso4, setPermiso4] = useState(null);
  const [cargo, setCargo] = useState(null);
  const [sumas, setSumas] = useState({
    Numero: 0,
    Cantidad: 0,
    SubTotal: 0,
    Descuento: 0,
    ISV: 0,
    Total: 0
  });

  const obtenerEncabezado = async () => {

    const tempo = await getEncabezadoRequisa(Numero);
    // console.log(tempo)
    if (tempo.length > 0) {
      const tempoDetalle = await getDetalleRequisa(Numero)
      setPurchaseInfo(tempo[0]);
      // console.log(tempoDetalle);
      setPurchaseDetalle(tempoDetalle);


      tempoDetalle.forEach(async detalle => {
        // PERMISO 1
        if (detalle.Permiso3 === true) {
          const tempo1 = await firmas.filter(firma => firma.idpersonal === '06580');
          setPermiso3(tempo1);
        }
        // PERMISO 3
        if (detalle.Permiso1 === true) {
          const tempo3 = await firmas.filter(firma => firma.idpersonal === '04007');
          setPermiso1(tempo3);
        }
        // PERMISO 4
        if (detalle.Permiso4 === true) {
          const tempo4 = await firmas.filter(firma => firma.idUser === tempo[0]?.IdSolicita);
          // const tempo4 = await obtenerFirmas(tempo[0]?.IdSolicita);
          setPermiso4(tempo4);
          setArea(tempo[0]);
        }


      });

      const pases = tempoDetalle.filter(detalle => detalle.IdTipo === 1 || detalle.IdTipo === 3 || detalle.IdTipo === 4)
      if (pases.length > 0) {
        // console.log('asdfasdf')
        const tempo4 = await firmas.filter(firma => firma.idUser === pases[0]?.IdSolicita);
        setPermiso4(tempo4);
        setArea(pases[0]);
      }
      // console.log('asignacion de suma', sumaTempo)
      // setSumas(sumaTempo);

    } else {
      messages.current.show({ severity: 'warn', summary: '', detail: ' Requisa no encontrada.', sticky: true });
    }
  }

  const setArea = (detalle) => {
    switch (detalle.IdSolicita) {
      // DIRECTOR
      // ALBERTO K
      case 1434:
        setCargo('D');
        break;

      // GERENTES
      case 'javierv':
        setCargo('G');
        break;
      // JOSE TREJO
      case 1420:
        setCargo('G');
        break;
      // JOSE TREJO
      case 1430:
        setCargo('G');
        break;
      // JOSE LUIS DIAZ
      case 1428:
        setCargo('G');
        break;



      // COORDINADOR
      // Jimmy Romero
      case 1419:
        setCargo('C');
        break;
      // Jimmy Romero
      case 1451:
        setCargo('C');
        break;
      // DIANY PUERTO
      case 1436:
        setCargo('C')
        break;
      // ROBERTO MARTINEZ
      case 1423:
        setCargo('C')
        break;
      // GEOVANNY MEJIA
      case 1455:
        setCargo('C')
        break;
      // GEOVANNY MEJIA
      case 1545:
        setCargo('C')
        break;
      // LUIS RAMOS
      case 54:
        setCargo('C')
        break;
      // LUIS RAMOS
      case 1433:
        setCargo('C')
        break;
      // LUZ MOLINA
      case 1432:
        setCargo('C')
        break;
      // LUZ MOLINA
      case 1463:
        setCargo('C')
        break;
      case 1431:
        setCargo('C')
        break;
      // NORMA FIGUEROA
      case 1426:
        setCargo('C')
        break;
      case 1425:
        setCargo('C')
        break;

      default:
        break;
    }
  }
  useLayoutEffect(() => {
    obtenerEncabezado()
  }, [Numero])

  useEffect(() => {

    let sumaTempo = {
      Numero: 0,
      Cantidad: 0,
      SubTotal: 0,
      Descuento: 0,
      ISV: 0,
      Total: 0
    }
    purchaseDetalle.forEach(detalle => {
      // console.log('Sumas cambio');
      sumaTempo.Numero++;
      sumaTempo.Cantidad += detalle.Quantity;
      sumaTempo.SubTotal += detalle.Price * detalle.Quantity;
      sumaTempo.ISV += detalle.ISV;
      sumaTempo.Descuento += detalle.Descuento;
      sumaTempo.Total += (detalle.Price * detalle.Quantity) + detalle.ISV - detalle.Descuento;
      // console.log('Sumas a asignar', sumaTempo)
    })
    setSumas(sumaTempo);
  }, [purchaseDetalle])



  return (
    <div>
      <div hidden={purchaseInfo === null || purchaseDetalle === null}>
        <div className='col-12 OrdenesComprasReporte p-4 ' style={{ width: '8.5in', height: '11in' }}>

          {/* TITLE */}
          <div className='encabezadoPPF col-12 d-flex align-items-center justify-content-around' style={{ fontSize: '1.3rem' }}>
            <div >
              <img src={logo} alt="" width={250} />
            </div>
            <div>
              <div className="row border border-dark px-5">
                Requisición de Compra
              </div>
              <div className="row">
                <div className='col col-2 px-1 border border-dark'>
                  No:
                </div>
                <div className='col px-2 border border-dark text-center'>
                  <strong>{purchaseInfo?.PurchaseRequest}</strong>
                </div>
              </div>
              <div className='text-center' style={{ lineHeight: '0.5rem' }}>
                <small>
                  Prioridad: {purchaseInfo?.Priority}
                </small>
              </div>
            </div>
          </div>

          {/* ENCABEZADO */}
          <div className="encabezadoInfo">
            <table id='purcahseInfo' className='col-12'>
              <tbody>
                <tr>
                  <td className="col-2 dark">
                    Fecha Creación:
                  </td>
                  <td className="colum-width-medium">
                    {getDateTimeStringSQL(new Date(purchaseInfo?.Date))}
                  </td>
                  <td className="col-2 dark">
                    Tipo:
                  </td>
                  <td className="col-2">
                    {purchaseInfo?.Tipo}
                  </td>
                  <td className="col-2" style={{ borderRight: 'none' }}>

                  </td>
                  <td className="col-2" style={{ borderLeft: 'none' }}>

                  </td>
                </tr>
              </tbody>
              <tr>
                <td className="col-2 dark">
                  Área:
                </td>
                <td className="colum-width-medium">
                  {textTemplate(purchaseInfo?.Area)}
                </td>
                <td className="col-2 dark">
                  Creado Por:
                </td>
                <td className="col-2">
                  {textTemplate(purchaseInfo?.UserCreate)}
                </td>
                <td className="col-2 dark">
                  Solicitado Por:
                </td>
                <td className="col-2">
                  {textTemplate(purchaseInfo?.SolicitaN)}
                </td>
              </tr>
            </table>
          </div>

          {/* AUTORIZACIONES */}
          <div className="autorizaciones col-12 mt-3">
            <div className='encabezado border border-dark col-12 text-center dark '>
              Asignaciones
            </div>
            <table id='purchasefirmas' className='col-12 '>
              <tbody>
                <tr className="dark col-12">
                  <td>Coordinador</td>
                  <td>Gte Departamento</td>
                  <td>Director Area</td>
                  <td>Finanzas</td>
                  <td>Plant Manager</td>
                </tr>
                <tr className="col-12 firmas">
                  <td>
                    {cargo === 'C' ? (permiso4 === null ? null : <img src={'data:image/png;base64,' + permiso4} alt="" />) : ''}
                  </td>
                  <td>
                    {cargo === 'G' ? (permiso4 === null ? null : <img src={'data:image/png;base64,' + permiso4} alt="" />) : ''}
                  </td>
                  <td>
                    {cargo === 'D' ? (permiso4 === null ? null : <img src={'data:image/png;base64,' + permiso4} alt="" />) : ''}
                  </td>
                  <td>
                    {permiso1 === null ? null : <img src={'data:image/png;base64,' + permiso1} alt="" />}
                  </td>
                  <td>
                    {permiso3 === null ? null : <img src={'data:image/png;base64,' + permiso3} alt="" />}
                  </td>

                </tr>

              </tbody>
            </table>
          </div>


          {/* DETALLE */}
          <div className="detail mt-3">
            <table id='purchaseDetalle' className="col-12 tableClear">
              <thead>
                <tr className='dark col-12'>
                  <td style={{ width: '10%' }}>Código</td>
                  <td className='col-4'>Producto</td>
                  <td style={{ width: '7%' }}>Cantidad</td>
                  <td>Unid</td>
                  <td style={{ width: '8.2%' }}>Desc</td>
                  <td>C</td>
                  <td>Precio</td>
                  <td style={{ width: '8%' }}>ISV</td>
                  <td style={{ width: '8%' }}>SubTotal</td>
                  <td style={{ width: '8%' }}>Total</td>
                </tr>
              </thead>
              <tbody>
                {purchaseDetalle.map(detalle => {
                  return (
                    <tr style={{ fontSize: '0.9rem' }} className='col-12'>
                      <td>{detalle.CodigoProducto}</td>
                      <td>{detalle.NombreProducto + '-' + detalle.Description}</td>
                      <td className='text-end' >{formatNumber(detalle.Quantity)}</td>
                      <td>{textCenterTemplate(detalle.UnitSimbol)}</td>
                      <td className='text-end' >{detalle.Descuento === 0 ? '' : formatNumber(detalle.Descuento)}</td>
                      <td>{textCenterTemplate(detalle.CurrencySymbol)}</td>
                      <td className='text-end' >{detalle.Price === 0 ? '' : formatNumber(detalle.Price)}</td>
                      <td className='text-end' >{detalle.ISV === 0 ? '' : formatNumber(detalle.ISV)}</td>
                      <td className='text-end' >{detalle.SubTotal === 0 ? '' : formatNumber(detalle.SubTotal)}</td>
                      <td className='text-end' >{detalle.Total === 0 ? '' : formatNumber((detalle.Price * detalle.Quantity) + detalle.ISV - detalle.Descuento)}</td>
                    </tr>
                  )
                })}

              </tbody>
            </table>


            {/* TOTALES */}
            <table id='purchaseSumas' className='tableClear'>
              <tfoot>
                <tr className='col-12'>
                  <td className='col-1'>{sumas.Numero}</td>
                  <td style={{ width: '36%' }}></td>
                  <td style={{ width: '10%' }}>{formatNumber(sumas.Cantidad)}</td>
                  <td className='border-end border-end border-bottom border-start border-dark text-end px-2' style={{ width: '30%' }}>SubTotal:</td>
                  <td style={{ width: '8%' }} className='text-center'>L</td>
                  <td style={{ width: '8%' }} className='text-end'>{formatNumber(sumas.SubTotal)}</td>
                </tr>
                <tr className='col-12'>
                  <td className='col-1'></td>
                  <td style={{ width: '36%' }}></td>
                  <td style={{ width: '10%' }}></td>
                  <td className='border border-dark text-end px-2' style={{ width: '30%' }}>Desc:</td>
                  <td style={{ width: '8%' }} className='text-center'>L</td>
                  <td style={{ width: '8%' }} className='text-end'>{formatNumber(sumas.Descuento)}</td>
                </tr>
                <tr className='col-12'>
                  <td className='col-1'></td>
                  <td style={{ width: '36%' }}></td>
                  <td style={{ width: '10%' }}></td>
                  <td className='border border-dark text-end px-2' style={{ width: '30%' }}>ISV:</td>
                  <td style={{ width: '8%' }} className='text-center'>L</td>
                  <td style={{ width: '8%' }} className='text-end'>{formatNumber(sumas.ISV)}</td>
                </tr>
                <tr className='col-12'>
                  <td className='col-1'></td>
                  <td style={{ width: '36%' }}></td>
                  <td style={{ width: '10%' }}></td>
                  <td className='border border-dark text-end px-2' style={{ width: '30%' }}>Total:</td>
                  <td style={{ width: '8%' }} className='text-center'>L</td>
                  <td style={{ width: '8%' }} className='text-end'>{formatNumber(sumas.Total)}</td>
                </tr>

              </tfoot>
            </table>
          </div>

          <div className="PruchaseComent">
            <div className="col-12 d-flex mt-3">
              <div className='dark border border-dark p-1'>Comentario:</div>
              <div className='ms-1'>
                {purchaseInfo?.Comment}
              </div>
            </div>
            <div className='col-11 d-flex justify-content-end mt-4'>
              <div>Fecha Impresión</div>
              <div className='px-2'>{fechaLocalTemplate(new Date())}</div>
            </div>
          </div>
        </div>
      </div>
      <div hidden={purchaseInfo !== null || purchaseDetalle !== null}>
        <Messages ref={messages}></Messages>
      </div>
    </div>
  )
}

export default RequisasComprasReporte